<app-site-selector
  [ctx]="ctx"
  (selectionChange)="refresh()"
  (refresh)="refresh()"
  [canSelectAllClusters]="true"
  [showDatePicker]="false"
  [datePickerSlug]="'journal'"
  [isLoading]="isLoading"
>
  <div class="search-input">
    <label>{{ 'Type' | translate }}</label>
    <ng-select
      class="type"
      [(ngModel)]="filters.type"
      (change)="refresh()"
      [disabled]="isLoading"
      [multiple]="true"
      [placeholder]="translate.instant('All')"
    >
      <ng-option *ngFor="let type of EventTypes" [value]="type">{{ 'Event.type.' + type | translate }}</ng-option>
    </ng-select>
  </div>
  <div class="search-input">
    <label>{{ 'Event' | translate }}</label>
    <ng-select
      (change)="refresh()"
      [(ngModel)]="filters.subType"
      [disabled]="isLoading"
      [multiple]="true"
      [placeholder]="translate.instant('All')"
      class="sub-type"
    >
      <ng-option *ngFor="let subType of availableSubTypes" [value]="subType">{{ subType.label }}</ng-option>
    </ng-select>
  </div>
  <div class="search-input">
    <label>{{ 'Severity' | translate }}</label>
    <ng-select
      class="severity"
      [(ngModel)]="filters.severity"
      (change)="refresh()"
      [disabled]="isLoading"
      [multiple]="true"
      [placeholder]="translate.instant('All')"
    >
      <ng-option value="1">LOW</ng-option>
      <ng-option value="2">MEDIUM</ng-option>
      <ng-option value="3">HIGH</ng-option>
    </ng-select>
  </div>
  <div class="search-input">
    <label>{{ 'IP' | translate }}</label>
    <input
      type="text"
      [(ngModel)]="filters.ip"
      [disabled]="isLoading"
      class="form-control"
      autocomplete="off"
      (change)="refresh()"
    />
  </div>
  <button
    app-date-range-selector
    [disabled]="isLoading"
    [range]="filters.period.range"
    [minDateDays]="365"
    [ranges]="['15M', '1H', '4H', 'T', 'Y', '7d', '30d', '90d', '12months']"
    (rangeChange)="onPeriodEmitted($event)"
    [timePicker]="true"
    class="btn btn-primary"
    id="reportrange-journalbis"
  >
    <i class="icofont icofont-ui-calendar mr-2"></i>
    <span></span>
    <div class="arrow-down"></div>
  </button>
</app-site-selector>

<div class="card mt-4">
  <div class="col-md-12">
    <div class="row" style="padding-top: 15px">
      <div class="col-md-12 mt-2 flex-align-items">
        <h4>
          {{ 'Journal' | translate }}
          <span class="badge-container">
            <app-help hrefKey="ExternalHelp.journal" style="font-size: 110%" />
          </span>
        </h4>
      </div>
    </div>

    <ngx-datatable
      [messages]="{ emptyMessage: translate.instant('NoData') }"
      #logsTable
      class="data-table table-responsive mb-3"
      columnMode="force"
      [limit]="size"
      [rows]="logs"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="40"
      [rowClass]="getRowClass"
    >
      <ngx-datatable-row-detail [rowHeight]="'auto'">
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-row-detail-template>
          <div style="padding: 20px">
            <json-viewer [json]="row.event" [expanded]="true"></json-viewer>
          </div>
        </ng-template>
      </ngx-datatable-row-detail>

      <ngx-datatable-column [minWidth]="90" [maxWidth]="90">
        <ng-template [typedTemplate]="rowType" let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
          <span (click)="toggleExpandRow(row)" class="ogo-link" style="font-size: 12px">
            <a
              href="javascript:void(0)"
              class="ogo-link icon"
              [class.icon-angle-down]="expanded"
              [class.icon-angle-right]="!expanded"
              style="font-size: 10px"
              title="{{ 'Details' | translate }}"
            >
            </a>
            {{ 'Details' | translate }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [width]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Date' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ row.date | dateFormat }}">{{ row.date | dateFormat }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="2">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Site' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ row.site }}">{{ row.site }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="3">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Event' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="row.subtype == 'newIpBlocked'; else genericSubtype" (click)="!row.outOfDate && trackEvent(row)">
            <a [ngClass]="{ clickable: !row.outOfDate }" [ngStyle]="{ cursor: row.outOfDate ? 'default' : 'cursor' }">
              <span class="mr-2">{{ row.subtypeLabel }}</span>
              <div
                *ngIf="row.event.countryCode2"
                [attr.title]="countries[row.event.countryCode2]"
                class="fi fi-{{ row.event.countryCode2 | lowercase }}"
              ></div>
              <span class="ml-2">{{ row.event.ip }}</span>
            </a>
          </span>
          <ng-template #genericSubtype>
            <div class="flex-align-items">
              <span *ngIf="row.experimental" class="badge-outline mr-2" style="padding: 0 5px">{{
                'Experimental' | translate
              }}</span>
              @if (
                !row.outOfDate && CLICKABLE_TYPES.includes(row.type) && !NON_CLICKABLE_SUBTYPES.includes(row.subtype)
              ) {
                <span (click)="trackEvent(row)"
                  ><a>{{ row.subtypeLabel }}</a></span
                >
              } @else {
                {{ row.subtypeLabel }}
              }
              <span *ngIf="row.subtype == 'siteRateLimit'"
                >&nbsp;({{ 'numberOfIPs' | translate }}: {{ row.event.totalIPs }})</span
              >
              @if (row.subtype == 'siteRateLimit') {
                <app-help tooltipKey="SiteRateLimitTooltip" tooltipPlacement="right" />
              }
            </div>
          </ng-template>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [width]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Type' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ 'Event.type.' + row.type | translate | titlecase }}">{{
            'Event.type.' + row.type | translate | titlecase
          }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [width]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Cluster' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ row.cluster?.name }}">{{ row.cluster?.name ?? '-' }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [minWidth]="90" [maxWidth]="90">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Severity' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ EventSeverity[row.severity] || '-' }}" class="severity-{{ EventSeverity[row.severity] }}">{{
            EventSeverity[row.severity] || '-'
          }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-curPage="filters.index" let-pageSize="size">
          <small class="ogo-ngx-datatable-footer"
            >Total : {{ total | number: '' : (lang == 'fr' ? 'fr-FR' : 'en-US') }} {{ 'entrie' | translate
            }}{{ total > 1 ? 's' : '' }}
          </small>
          <datatable-pager
            [pagerLeftArrowIcon]="pager.PREV"
            [pagerRightArrowIcon]="pager.NEXT"
            [pagerPreviousIcon]="pager.FIRST"
            [pagerNextIcon]="pager.LAST"
            [page]="index + 1"
            [size]="size"
            [count]="total"
            (change)="changePage($event)"
          >
          </datatable-pager>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
